class LocalizationPopup extends HTMLElement {
  connectedCallback() {
    this.checkOpen();
  }

  checkOpen = () => {
    if(this.dataset.open != undefined && localStorage.getItem('localization-popup') === null && window.location.pathname !== '/') {
      this.open();
    }
  }

  open = () => {
    this.classList.add('open');
    if(this.dataset.open != undefined) {
      localStorage.setItem('localization-popup', 'true');
    }
  }

  close = () => {
    this.classList.remove('open');
  }
}
if (!customElements.get('localization-popup')) {
  customElements.define('localization-popup', LocalizationPopup);
}

//se per testare si vuole far "dimenticare" al browser che l'utente ha già visto il popup, scrivi nella console del browser: localStorage.removeItem('localization-popup'); e premi invio


class LocalizationOpener extends HTMLElement {

  connectedCallback() {
    this.addEventListener('click', this.openPopup.bind(this));
  }

  openPopup = () => {
    const popup = document.querySelector('localization-popup');
    if(popup != undefined)
      popup.open();
  }

}
if (!customElements.get('localization-opener')) {
  customElements.define('localization-opener', LocalizationOpener);
}


// transparent header in homepage

document.addEventListener('DOMContentLoaded', () => {

    // solo homepage
    if (!document.body.classList.contains('home-page')) return;

    const updateHeader = () => {

            // Con menu o carrello aperti il tema blocca la pagina (body.scroll-y-off)
            // e salva la posizione reale in body.style.top: window.scrollY lì vale 0
            const scrollY = document.body.classList.contains('scroll-y-off')
                ? Math.abs(parseInt(document.body.style.top || '0', 10))
                : window.scrollY;

            if (scrollY >= window.innerHeight) {
                document.body.classList.add('scrolled-hero');
            } else {
                document.body.classList.remove('scrolled-hero');
            }

        };


    updateHeader();
    window.addEventListener('scroll', updateHeader);

});

// end transparent header in homepage